import FilterItem from '@/components/PCP/FilterItem'
import { Filter } from '../../shopify/api'

interface FilterSectionProps {
  title: string
  items: Filter
  currentSelectedItem: string
  handleSelectItem: (itemLabel: string) => void
}

const FilterSection: React.FC<FilterSectionProps> = ({
  title,
  items,
  currentSelectedItem,
  handleSelectItem,
}) => {
  const handleSelect = (itemLabel: string) => {
    const urlEncodedItem = encodeURIComponent(itemLabel)
    if (urlEncodedItem === currentSelectedItem) {
      handleSelectItem('')
    } else {
      handleSelectItem(urlEncodedItem)
    }
  }

  return (
    <div data-test={`filter-section-${title}`}>
      <h3 className='font-quicksand font-bold text-sm mb-[10px]'>{title}</h3>
      {items.values.map(({ id, label }, index) => {
        const isActive = decodeURIComponent(currentSelectedItem) === label
        return (
          <FilterItem
            index={index}
            key={id}
            label={label}
            onSelect={() => handleSelect(label)}
            active={isActive}
          />
        )
      })}
    </div>
  )
}

export default FilterSection
